
import { getSizeOption, fractionalSizeOptions } from '../options';

export default {
	allSelectedOptions: state => {
		var result = [];
		
		for(var typeId in state.optionSelections)
		{
			result = [
				...result,
				...Object.values(state.optionSelections[typeId]),
			]
		}

		return result;
	},

	selectedOptionList: state => {
		var result = [];
		
		for(var typeId in state.optionSelections)
		{
			result = [
				...result,
				...state.optionSelections[typeId].map(id => state.options[id]),
			]
		}

		return result;
	},

	productWidthOptions: state => {
		var min = state.product.width_options[0];
		var max = state.product.width_options[state.product.width_options.length - 1];
		var result = [];

		for(var i=min; i<=max; i++)
			result.push(i);

		return result;
	},

	productHeightOptions: state => {
		var min = state.product.height_options[0];
		var max = state.product.height_options[state.product.height_options.length - 1];
		var result = [];

		for(var i=min; i<=max; i++)
			result.push(i);

		return result;
	},

	getOptionPrice: state => id => {
		var option = state.options[id];
		var width, height;

		// make sure option is valid
		if (!option)
		{
			console.error(`Invalid option ID: ${id}`);
			return 0;
		}

		// get width/height options
		width = Math.ceil(parseFloat(state.cartItem.width.whole) + fractionalSizeOptions[state.cartItem.width.fractional]);
		height = Math.ceil(parseFloat(state.cartItem.height.whole) + fractionalSizeOptions[state.cartItem.height.fractional]);

		width = getSizeOption(width, state.product.width_options);
		height = getSizeOption(height, state.product.height_options);
	
		if (option.price_type == 'fixed')
		{
			return parseFloat(option.fixed_price);
		}
		else if (option.price_type == 'width_only')
		{
			return parseFloat(option.price_grid[width]) || 0;
		}
		else if (option.price_type == 'width_and_height')
		{
			return parseFloat(option.price_grid[width][height]) || 0;
		}
		else
		{
			console.error(`Invalid price type when looking up price for option ${option.name}: ${option.price_type}`);
			return 0;
		}
	},

	getProductPrice: state => {
		var grid = state.product.price_grid;
		var width, height;

		// get width/height options
		width = Math.ceil(parseFloat(state.cartItem.width.whole) + fractionalSizeOptions[state.cartItem.width.fractional]);
		height = Math.ceil(parseFloat(state.cartItem.height.whole) + fractionalSizeOptions[state.cartItem.height.fractional]);

		width = getSizeOption(width, state.product.width_options);
		height = getSizeOption(height, state.product.height_options);

		if (!grid[width])
		{
			console.error(`Invalid width for product: ${width}`);
			return 0;
		}
		else if (!grid[width][height])
		{
			console.error(`Invalid height for product: ${height}`);
			return 0;
		}
		else
		{
			return grid[width][height];
		}
	}
}